let login: string;
let password: string;
let tabula: string;

const setUserLogin = (userlogin: string) => {
    login = userlogin;
};

export const getUserLogin = (): string => {
    return login;
};

const setUserPassword = (userPassword: string) => {
    password = userPassword;
};

export const getUserPassword = (): string => {
    const oidc_access_token = window['oidc_access_token'];
    return oidc_access_token || password;
};

const setTabulaIni = (tabulaIni: string) => {
    tabula = tabulaIni;
};

export const getTabulaIni = (): string => {
    return tabula;
};

export const setMetaData = (userlogin: string, userPassword: string, tabulaIni: string) => {
    setUserLogin(userlogin);
    setUserPassword(userPassword);
    setTabulaIni(tabulaIni);
};
